"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetClassIsGroupMap = exports.assetClassConfigurationMapper = exports.acceptableParentType = exports.getFloorBuildingAreaForDisplay = exports.getFloorAndBuildingForDisplay = exports.getFullAssetNameForDisplay = void 0;
const types_1 = require("../types");
const getFullAssetNameForDisplay = (display_name, optional_name) => {
    if (!display_name)
        return "";
    if (optional_name)
        return `${display_name} (${optional_name})`;
    return display_name;
};
exports.getFullAssetNameForDisplay = getFullAssetNameForDisplay;
function getFloorAndBuildingForDisplay(floorName, buildingName) {
    if (!floorName && !buildingName)
        return "";
    return `${floorName} Floor, ${buildingName} Building`;
}
exports.getFloorAndBuildingForDisplay = getFloorAndBuildingForDisplay;
function getFloorBuildingAreaForDisplay(floorName, buildingName, areaName) {
    if (!floorName && !buildingName && !areaName)
        return "";
    return `${getFloorAndBuildingForDisplay(floorName, buildingName)}, ${areaName}`;
}
exports.getFloorBuildingAreaForDisplay = getFloorBuildingAreaForDisplay;
function acceptableParentType(type) {
    switch (type) {
        case types_1.AssetClassNames.AREA:
            return types_1.AssetClassNames.FLOOR;
        case types_1.AssetClassNames.FLOOR:
            return types_1.AssetClassNames.BUILDING;
        default:
            return null;
    }
}
exports.acceptableParentType = acceptableParentType;
exports.assetClassConfigurationMapper = {
    [types_1.AssetClassNames.BUILDING]: "enable_building_asset_class",
    [types_1.AssetClassNames.FLOOR]: "enable_floor_asset_class",
    [types_1.AssetClassNames.AREA]: "enable_area_asset_class",
    // add space cloud config asset groups
    [types_1.AssetClassNames.BUILDING_SC]: "enable_building_sc_asset_class",
    [types_1.AssetClassNames.ZONE_SC]: "enable_zone_sc_asset_class",
    [types_1.AssetClassNames.ALLEY_SC]: "enable_alley_sc_asset_class",
    [types_1.AssetClassNames.MARKET_SC]: "enable_market_sc_asset_class",
    [types_1.AssetClassNames.DEPARTMENT_STORE_SC]: "enable_department_store_sc_asset_class",
    [types_1.AssetClassNames.GAS_STATION_SC]: "enable_station_sc_asset_class",
    [types_1.AssetClassNames.COMMUNITY_MALL]: "enable_community_mall_asset_class",
    [types_1.AssetClassNames.OFFICE_BUILDING]: "enable_office_building_asset_class",
    [types_1.AssetClassNames.SPECIALTY_STORE]: "enable_specialty_store_asset_class",
    [types_1.AssetClassNames.ROOM]: "enable_room_asset_class",
    [types_1.AssetClassNames.DESK]: "enable_desk_asset_class",
    [types_1.AssetClassNames.EVENT_SPACE]: "enable_event_space_asset_class",
    [types_1.AssetClassNames.SELL_DIVISION_OR]: "enable_sell_division_or_asset_class",
    [types_1.AssetClassNames.SELL_ZONE_OR]: "enable_sell_zone_or_asset_class",
    [types_1.AssetClassNames.PROVINCE_INSIDE_OR]: "enable_province_inside_or_asset_class",
    [types_1.AssetClassNames.AMPHOE_OR]: "enable_amphoe_or_asset_class",
    [types_1.AssetClassNames.STATION_OR]: "enable_station_or_asset_class",
    // add space cloud config assets
    [types_1.AssetClassNames.SPACE_SC]: "enable_space_sc_asset_class",
};
exports.assetClassIsGroupMap = {
    // Asset Groups
    [types_1.AssetClassNames.BUILDING]: true,
    [types_1.AssetClassNames.FLOOR]: true,
    [types_1.AssetClassNames.AREA]: true,
    [types_1.AssetClassNames.BUILDING_SC]: true,
    [types_1.AssetClassNames.ZONE_SC]: true,
    [types_1.AssetClassNames.ALLEY_SC]: true,
    [types_1.AssetClassNames.MARKET_SC]: true,
    [types_1.AssetClassNames.DEPARTMENT_STORE_SC]: true,
    [types_1.AssetClassNames.GAS_STATION_SC]: true,
    [types_1.AssetClassNames.COMMUNITY_MALL]: true,
    [types_1.AssetClassNames.OFFICE_BUILDING]: true,
    [types_1.AssetClassNames.SPECIALTY_STORE]: true,
    [types_1.AssetClassNames.SELL_DIVISION_OR]: true,
    [types_1.AssetClassNames.SELL_ZONE_OR]: true,
    [types_1.AssetClassNames.PROVINCE_INSIDE_OR]: true,
    [types_1.AssetClassNames.AMPHOE_OR]: true,
    [types_1.AssetClassNames.STATION_OR]: true,
    // Assets
    [types_1.AssetClassNames.ROOM]: false,
    [types_1.AssetClassNames.EVENT_SPACE]: false,
    [types_1.AssetClassNames.DESK]: false,
    [types_1.AssetClassNames.SPACE_SC]: false,
};
//# sourceMappingURL=assetUtils.js.map